import React from 'react';
import { toggleClass } from '../../../util/dom';

export type BgisBasemapProps = {
  children?: React.ReactNode;
};

export const BgisBasemap : React.FC<BgisBasemapProps> = ({ children }: BgisBasemapProps) => {
  return (
    <section className="bgis-basemap show bgis-toggled-overlayable">
        <header className='bgis-basemap-header'><button onClick={() => toggleClass('.bgis-map-area','show-basemap') }>x</button></header>
        <div className='bgis-basemap-body'>{children}</div>
    </section>);
};